import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { insertSchema } from '../../../Modais/AgendamentoRetornoCliente/@schema/insertSchema'
import { api } from '../../../../../../../services/api'
import { useMutation } from 'react-query'

async function agendarRetorno(params) {
  const response = await api.post('/site/v2/orcamento-crm/inserir-agendamento-proposta', {
    ...params,
  })
  return response.data
}

export function useFormAgendamento({ numeroNota, infoProposta, optionsQuery }) {
  const methods = useForm({
    resolver: zodResolver(insertSchema),
  })

  const { setValue } = methods

  const { mutateAsync: handleAgendarRetorno, isLoading: isLoadingAgendamento } = useMutation({
    mutationFn: agendarRetorno,
    ...optionsQuery,
  })

  useEffect(() => {
    setValue('numero_nota', numeroNota)
    setValue('codigo_parceiro', infoProposta?.cliente?.codigo_parceiro)
    setValue('codigo_contato', infoProposta?.codigo_contato)
    setValue('numero_pedido', infoProposta?.numero_pedido)
    setValue('agendamentoRetorno', 'EMAIL')
  }, [setValue, numeroNota, infoProposta])

  return {
    methods,
    agendarRetorno: handleAgendarRetorno,
    isLoadingAgendamento,
    onChangeSelect: (value) => setValue('agendamentoRetorno', value),
    agendamentoTipo: methods.watch('agendamentoRetorno') ?? 'EMAIL',
  }
}
